/* @flow weak */
import createChainedFunction from 'utils/createChainedFunction';
import BoxBody from 'components/BoxBody.jsx';
import Dialog from 'components/Dialog.jsx';
import EmailForm from 'user/components/EmailForm.jsx';
import PropTypes from 'prop-types';
import * as React from 'react';

const SetUserEmailModal = props => (
  <Dialog
    {...props}
    title="What is your email address?"
    subtext={`${props.message || 'We’ll email your message history to the address you enter.'}
      This will be your primary email address for Remind.`}
    size="small">
    <BoxBody divided>
      <EmailForm
        onSave={
          props.closeOnSave
            ? createChainedFunction(props.onRequestHide, props.onSave)
            : props.onSave
        }
      />
    </BoxBody>
  </Dialog>
);
SetUserEmailModal.propTypes = {
  onSave: PropTypes.func,
  message: PropTypes.string,
  closeOnSave: PropTypes.bool,
};
SetUserEmailModal.defaultProps = {
  onSave: () => {},
  closeOnSave: true,
};
export default SetUserEmailModal;
